import React, { useContext, useEffect, useState } from 'react';
import { GridLoader } from 'react-spinners';

import { useTimer } from '@/shared/hooks/export';
import { articleApi } from '@/modules/articles/api';
import { Article } from '@/modules/articles/model/article';
import { WidgetContainer, WidgetContainerContext, useWidgetNavigate } from '@/core/widgets/export';
import type { PinnedWidgetPreferences } from '@/modules/articles/widgets/pinned/pinned-series-widget';
import { PageControl } from '@/shared/pagination/export';
import { Menu } from '@/core/menu/export';
import theme from '@/shared/theme/index.module.scss';
interface SeriesScrollerProps {
  articles?: Article[];
  includeGenres: string[];
  dark?: boolean;
  title?: JSX.Element;
  onArticlesChange: (articles?: Article[]) => void;
  onPageChange?: (page: number) => void;
  initialPage?: number;
}

export default function SeriesScroller(props: React.PropsWithChildren<SeriesScrollerProps>) {
  const [articles, setArticles] = useState<Article[]>();
  const [offset, setOffset] = useState<number>(props.initialPage ?? 0);

  const widgetContainer = useContext<WidgetContainer>(WidgetContainerContext);
  const navigate = useWidgetNavigate();
  const includeGenresKey = props.includeGenres.join(',');

  const fetchData = (offset: number, clearCurrent: boolean) => {
    if (clearCurrent) setArticles(undefined);

    articleApi
      .getArticlesBySection(undefined, {
        page: offset,
        limit: 15,
        includeGenres: props.includeGenres,
      })
      .then(value => {
        setArticles(value.content);
      });
  };

  const setPage = (offset: number) => {
    setArticles(undefined);
    setOffset(offset);
    fetchData(offset, true);
    props.onPageChange?.(offset);
  };

  useEffect(() => {
    props.onArticlesChange(articles);
    // eslint-disable-next-line
  }, [articles]);

  useEffect(() => {
    fetchData(offset, true);
    // eslint-disable-next-line
  }, [includeGenresKey]);

  useEffect(() => {
    props.onPageChange?.(offset);
    // eslint-disable-next-line
  }, [offset]);

  useTimer(
    30000,
    () => {
      fetchData(offset, false);
    },
    false,
  );

  const bg = props.dark
    ? ''
    : (widgetContainer.getPreferences<PinnedWidgetPreferences>()?.color ?? 'note-yellow');
  return (
    <div className={`container-element h-100 ${bg}`}>
      <div className={'h-100 d-flex flex-column container-responsive-text'}>
        <PageControl
          offset={offset}
          onChange={setPage}
          dark={props.dark}
          onClose={() => navigate('/')}
          menu={<Menu />}
        />

        {!articles && (
          <div style={{ textAlign: 'center' }} className={'mt-5'}>
            <GridLoader color={theme.info} />
          </div>
        )}

        <div className={'flex-fill mt-3 overflow-auto '}>{props.children}</div>
      </div>
    </div>
  );
}
